
import ContactForm from '../components/ContactForm'
// import Sponsors from '../components/Sponsors'
import IntSlides from '../components/IntSlides'
// import BreadCrumbs from '../components/BreadCrumbs'
export default {
  auth: false,
  components: {
    // BreadCrumbs,
    // Sponsors,
    ContactForm,
    IntSlides
  },
  data () {
    return {
      lang: 'es',
      cont: {
        en: {
          tit1: 'Somos Piedras Bellisimas',
          par1: 'Piedras Bellisimas Inc. is a company dedicated to the wholesale of artificial grass (also known as artificial turf, synthetic grass, or synthetic turf), artificial Ivy, artificial mulch, artificial plants, and all you need to complete all your installation projects. Our mission consists of offering a great variety of artificial turf and materials required for your projects. At Piedras Bellisimas, we stand out for providing our customers with the best service and best products in the market.',
          tit2: 'Our Products',
          par2: 'We have the best quality products with a warranty of up to 15 years. It also looks better than its organic equivalent, always maintaining its vivid color with very low maintenance cost and maximum performance. Artificial grass is environmentally friendly since it does not consume energy or water and it doesn’t need chemical products that can be harmful, which allows reducing the contamination and the harm against the environment.',
          tit3: 'It doesn’t matter how big or small your project is',
          par3: 'We have all the stock and a great variety to guarantee that you get all materials needed to make your artificial grass, Ivy wall or mulch project happen fast, with the best quality and efficiency. ',
          tit4: '¡We are breaking boundaries!',
          par4: 'We offer delivery and cover projects all over South-Florida. If your project requires a special delivery you can contact us. We deliver nationwide, The Caribbean, and Latin America. Our goal is to make Piedras Bellisimas a leading company of artificial grass, and to be one of the main distributors all over the state of Florida, creating along the way innovative projects that satisfy all our client`s needs.'
        },
        es: {
          tit1: 'Somos Piedras Bellisimas',
          par1: 'Piedras Bellísimas es una empresa emprendedora en el área de bisutería, que ofrece productos y servicios de calidad, buscando la satisfacción de nuestros clientes y colaboradores, a través de la práctica de una buena cultura organizacional, la innovación y nuestra prioridad de ser eficientes, ya que es el valor que nos caracteriza.',
          tit2: 'Nuestros Productos',
          par2: 'Somos una empresa dedicada a la venta de bisutería para la mujer de hoy, ama de casa, estudiante y profesional, ofrecemos una variedad de productos de excelente calidad y con un precio accesible para todo público.',
          tit3: 'Stock',
          par3: 'Nuestro stock se destaca por la variedad de productos en el área de bisutería entre los que tienen gran demanda son artículos como anillos, cadenas y collares, dijes, zarcillos, entre otros. Adicionalmente variedad de productos de maquillaje, skincare especializado para la mujer venezolana.',
          tit4: '¡Queremos llegar más allá!',
          par4: 'Piedras Bellísimas, se ve ofreciendo servicios a nivel nacional e internacional, con estructura propia y excelente atención, convirtiéndonos en una importante opción en el mercado por calidad e innovación, manteniéndonos como una empresa líder y en constante crecimiento con una marca establecida.'
        }
      },
      topSlides: [
        {
          title: '',
          img: 'slider2.jpg'
        },
        {
          title: '',
          img: 'slider.jpg'
        }
      ],
      rightSlides: [
        {
          img: 'about5.jpg'
        },
        {
          img: 'about1.jpg'
        },
        {
          img: 'about3.jpg'
        },
        {
          img: 'about10.jpg'
        }
      ],
      leftSlides: [
        {
          img: 'about9.jpg'
        },
        {
          img: 'about4.jpg'
        },
        {
          img: 'about6.jpg'
        },
        {
          img: 'about2.jpg'
        }
      ]
    }
  },
  head: {
    title: 'Acerca de Nosotros',
    meta: [
      { hid: 'og:title', name: 'og:title', content: 'Acerca de Nosotros' },
      { hid: 'description', name: 'description', content: 'Acerca de Nosotros' }
    ]
  }
}
